import { TenantSelector, type TenantSelectorTenant } from '@equinoxx/react'
import { useTenantlessAuthedApiContext } from './App/AppTenantlessAuthedApi'
import { useTenantlessDeploymentContext } from './App/AppTenantlessDeploymentProvider'
import { GO_API } from '../classes/appApi'

interface GoTenantSelectorProps {
    autoLoginIfOnlyOne?: boolean
    selectFunction: (
        tenant: TenantSelectorTenant,
        environment: string,
        instance: string
    ) => Promise<void> | void
}

const GoTenantSelector = (props: GoTenantSelectorProps) => {
    const api = useTenantlessAuthedApiContext()
    const deployment = useTenantlessDeploymentContext()

    return (
        <TenantSelector
            api={api}
            environment={deployment.environment}
            defaultInstance={process.env.REACT_APP_INSTANCE ?? ''}
            autoLoginIfOnlyOne={props.autoLoginIfOnlyOne ?? true}
            endpoints={{
                deploymentList: `${GO_API}/token/deployments`,
                tenantByIdTemplate: `${GO_API}/config/tenants/{id}`,
                lookupByDisplayId: `${GO_API}/config/tenants/lookup-by-display-id`,
                removeDeployment: `${GO_API}/token/deployments/remove`,
            }}
            selectFunction={props.selectFunction}
        />
    )
}

export default GoTenantSelector
